import uuidv4 from 'uuid/v4'

// Backend limit is 20 chars, metadata is 4
const LIMIT = 16

// Add metadata to clOrdID for tracking
export const getClOrdID = (compact: boolean): string => {
  const id = uuidv4().replace(/-/g, '').slice(0, LIMIT)
  const device = compact ? 'm' : 'd' // mobile / desktop
  return `${id}web${device}`
}
